export function HeartIcon() {
    return <svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.0683 19.0755C11.7566 19.1855 11.2433 19.1855 10.9316 19.0755C8.27331 18.168 2.33331 14.3821 2.33331 7.96547C2.33331 5.13297 4.61581 2.84131 7.42998 2.84131C9.09831 2.84131 10.5741 3.64798 11.5 4.89464C12.4258 3.64798 13.9108 2.84131 15.57 2.84131C18.3841 2.84131 20.6666 5.13297 20.6666 7.96547C20.6666 14.3821 14.7266 18.168 12.0683 19.0755Z" stroke="#1EF875" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    
}

